import type { ReactNode } from "react";

type Tone = "primary" | "accent" | "secondary";

const toneClasses: Record<Tone, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-foreground-700",
};

interface SummaryCardProps {
  title: string;
  value: ReactNode;
  icon: string;
  sub?: ReactNode;
  tone?: Tone;
}

export default function SummaryCard({
  title,
  value,
  icon,
  sub,
  tone = "primary",
}: SummaryCardProps) {
  return (
    <div className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5">
      <div className="flex items-start justify-between">
        <div className="min-w-0">
          <p className="text-xs md:text-sm text-foreground-500 font-medium">
            {title}
          </p>
          <p className="mt-1.5 text-xl md:text-2xl font-heading font-bold text-foreground-950 truncate">
            {value}
          </p>
        </div>
        <span
          className={`w-10 h-10 rounded-md flex items-center justify-center shrink-0 ${toneClasses[tone]}`}
        >
          <i className={`${icon} text-xl`} />
        </span>
      </div>
      {sub && <div className="mt-2 text-xs text-foreground-500">{sub}</div>}
    </div>
  );
}